var video_viewer_default = {
  "video_player": "LL2rJ",
  "videoOverlay": "aaX6f",
  "video_container": "MAlAY"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
